package com.vamvisions.main.contact.domain.model

/** What a contact message is about, chosen by the visitor. */
enum class ContactTopic { APP_DEVELOPMENT, DIGITAL_PRODUCT, PARTNERSHIP, OTHER }
